var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row w-100 justify-content-between align-items-center py-2"},[_c('div',{staticClass:"text-capitalize",staticStyle:{"font-size":"1.3rem"},domProps:{"textContent":_vm._s(_vm.separador(_vm.breads))}}),(_vm.breads)?_c('div',{staticClass:"d-flex text-capitalize justify-content-end"},_vm._l((_vm.breads),function(bread,index){return _c('div',{key:index,style:(index > 0
          ? [{ 'padding-left': '7px', color: '#6c757d' }]
          : [{ 'font-weight': 400 }]),domProps:{"textContent":_vm._s(
        index < _vm.breads.length - 1
          ? bread + ' / '
          : bread.includes('_')
          ? _vm.separador(_vm.breads)
          : bread
      )}})}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }